const Sparkles = () => {
	return (
		<svg
			width='21'
			height='20'
			viewBox='0 0 21 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_1362_4748)'>
				<path
					d='M12.1459 5.33848C9.72145 4.83023 7.82648 2.93527 7.31832 0.51082C7.2559 0.213203 6.9934 0 6.68922 0C6.38504 0 6.12254 0.213203 6.06016 0.510859C5.55195 2.93527 3.65699 4.8302 1.23258 5.33836C0.934922 5.40074 0.72168 5.66328 0.72168 5.96742C0.72168 6.27156 0.934883 6.5341 1.23258 6.59648C3.65695 7.10473 5.55184 8.99965 6.06004 11.4241C6.12242 11.7217 6.38492 11.935 6.6891 11.935C6.99324 11.935 7.25578 11.7218 7.31816 11.4241C7.82641 8.99965 9.72141 7.10473 12.1458 6.5966C12.4435 6.53422 12.6567 6.27172 12.6567 5.96754C12.6567 5.6634 12.4435 5.40086 12.1459 5.33848Z'
					fill='white'
				/>
				<path
					d='M11.0833 15.9564C9.94107 15.717 9.04826 14.8241 8.80877 13.6818C8.74639 13.3841 8.48389 13.1709 8.17971 13.1709C7.87557 13.1709 7.61303 13.3841 7.55064 13.6818C7.31115 14.8241 6.4183 15.7169 5.27604 15.9563C4.97838 16.0187 4.76514 16.2813 4.76514 16.5854C4.76514 16.8895 4.97834 17.1521 5.27604 17.2145C6.41826 17.4539 7.31111 18.3468 7.55057 19.4891C7.61295 19.7867 7.87545 20 8.17963 20C8.48377 20 8.74631 19.7868 8.80869 19.4891C9.04818 18.3468 9.94103 17.4539 11.0833 17.2145C11.381 17.1521 11.5942 16.8896 11.5942 16.5854C11.5942 16.2813 11.381 16.0188 11.0833 15.9564Z'
					fill='white'
				/>
				<path
					d='M19.7674 10.0052C18.2234 9.68156 17.0167 8.47477 16.693 6.93082C16.6307 6.63316 16.3682 6.41992 16.064 6.41992C15.7598 6.41992 15.4973 6.63309 15.4349 6.93078C15.1112 8.47477 13.9045 9.68152 12.3605 10.0052C12.0629 10.0675 11.8496 10.3301 11.8496 10.6342C11.8496 10.9384 12.0628 11.2009 12.3605 11.2633C13.9045 11.587 15.1112 12.7937 15.4348 14.3377C15.4972 14.6354 15.7597 14.8486 16.0639 14.8486C16.368 14.8486 16.6306 14.6354 16.693 14.3377C17.0167 12.7937 18.2234 11.587 19.7674 11.2634C20.065 11.2009 20.2783 10.9384 20.2783 10.6343C20.2783 10.3302 20.0651 10.0676 19.7674 10.0052Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_1362_4748'>
					<rect
						width='20'
						height='20'
						fill='white'
						transform='translate(0.5)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Sparkles
